/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: StateChangeMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler = function() {
    com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_STATE_CHANGE);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler'] = com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","StateChangeMessageHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler.prototype.processMessage = function(message) {
    /** @type {string} */
    var oldType = message.getMessageType();
    /** @type {string} */
    var state = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_STATE);

    switch (state) {
		/** @deprecated */
        case com.inq.flash.client.data.MessageFields.DATA_STATE_QUEUED:
            message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_NEED_WAIT);
            break;

        case com.inq.flash.client.data.MessageFields.DATA_STATE_ASSIGNED:
            message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACCEPTED);

            /**
             * In ApplicationController preventDefault was called on external web link in opener
             * and webOpenerLinkHref was assigned, once the chat is assigned user is redirected.
             */
            var webOpenerLinkHref = this.getController().webOpenerLinkHref;

            if (webOpenerLinkHref) {
                window.parent.location.href = webOpenerLinkHref;
            }

            break;

        case com.inq.flash.client.data.MessageFields.DATA_STATE_CLOSED:
            message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_EXIT);
            break;

        case com.inq.flash.client.data.MessageFields.DATA_STATE_TRANSFER:
            message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_TRANSFER_RESPONSE);
            break;

        case com.inq.flash.client.data.MessageFields.DATA_STATE_CONFERENCE:
            message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_OWNER_TRANSFER_RESPONSE);
            break;

        case com.inq.flash.client.data.MessageFields.DATA_STATE_AGENT_IS_TYPING:
            message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_ACTIVITY);
            break;

		case com.inq.flash.client.data.MessageFields.DATA_STATE_MOVED_TO_ASYNC:
			message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_AUTHENTICATED_USER_RESPONSE);
			break;
	}

    if (oldType != message.getMessageType()) {
        this.getController().processMessage(message);
    }
};

/** @type {com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler} */
com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.StateChangeMessageHandler;
